import React from 'react';
import {
  BsAirplaneFill,
  BsBank,
  BsBuildingFill,
  BsCarFrontFill,
  BsCupHotFill,
  BsHospitalFill,
  BsLaptopFill,
  BsMortarboardFill,
  BsShop,
  BsTruck,
  BsBuildingsFill,
} from 'react-icons/bs';
import './IndustriesSection.css';

const INDUSTRIES_DATA = [
  { name: 'Healthcare', Icon: BsHospitalFill, color: '#0d9488' },
  { name: 'Education', Icon: BsMortarboardFill, color: '#f97316' },
  { name: 'Real Estate', Icon: BsBuildingFill, color: '#4caf50' },
  { name: 'Retail & E-commerce', Icon: BsShop, color: '#e11d48' },
  { name: 'Manufacturing', Icon: BsBuildingsFill, color: '#0d6efd' },
  { name: 'Logistics', Icon: BsTruck, color: '#d97706' },
  { name: 'Finance & Banking', Icon: BsBank, color: '#7c3aed' },
  { name: 'Travel & Hospitality', Icon: BsAirplaneFill, color: '#0891b2' },
  { name: 'Food & Restaurant', Icon: BsCupHotFill, color: '#ea580c' },
  { name: 'Automotive', Icon: BsCarFrontFill, color: '#2563eb' },
  { name: 'IT', Icon: BsLaptopFill, color: '#9333ea' },
];

const IndustriesSection = () => {
  return (
    <section className="sipl-industries-section py-5" aria-labelledby="industries-heading">
      <div className="container py-4">
        <div className="sipl-industries-heading text-center sipl-reveal-ttb">
          <span className="text-uppercase fw-bold sipl-text-teal small d-block mb-2">
            INDUSTRIES WE SERVE
          </span>
          <h2 id="industries-heading" className="display-6 fw-bold text-dark mb-3">
            Tailored solutions across key business sectors.
          </h2>
          <p className="text-muted fs-6 mx-auto mb-0">
            We work with companies across diverse domains where digital tools, automated workflows, and clean web applications drive real efficiency.
          </p>
        </div>

        <div className="sipl-industries-grid">
          {INDUSTRIES_DATA.map(({ name, Icon, color }, index) => (
            <div
              key={name}
              className="sipl-industry-tile sipl-reveal-btt"
              style={{ '--industry-color': color, transitionDelay: `${index * 0.06}s` }}
            >
              <Icon className="sipl-industry-icon" aria-hidden="true" />
              <h3>{name}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
